module.exports = __webpack_public_path__ + "img/v.2c6d26e7.png";